<template>
  <div id="body">
    <div class="title">
      <i class="el-icon-s-claim"></i> {{ title }}
      <div style="float: right; margin-right: 3%">
        <i class="el-icon-back" @click="toBack()"></i>
      </div>
    </div>


    <div style="width: 100%;margin: 0 auto">
      <img :src="img" style="width: 98%; margin-top: -10px; margin-left: 1%">
    </div>
  </div>
</template>

<script>
	export default {
	  name: "",
	  data() {
      return {
        img:'',
        title: '',
      };
	  },
	  methods: {
      toBack() {
        this.$router.go(-1)
      },
	  },
    created() {
	    console.log("=== report created ===")
      this.img = this.$route.query.img
      this.title = this.$route.query.title
    }
  };
</script>

<style scoped="scoped">
	
</style>
